import React, { Fragment } from "react"

import Tags from "../../../common/tags/Tags"
import TagItem from "../../../common/tags/TagItem"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"

import { getDisplayTagFromType } from "../../util"
import NotificationEntityPreview from "./NotificationEntityPreview"
import { notificationTypes } from "../../../../config/application-definitions"

const NotificationViewLinkDetails = ({ type, link, entity_id, isFetching }) => {
    let linkContainerComponent = null
    if (!isFetching) {
        if (entity_id) {
            linkContainerComponent = (
                <Fragment>
                    <h3>
                        <i className="icon icon-insights" />
                        Related{" "}
                        {(notificationTypes[type] &&
                            notificationTypes[type].label) ||
                            "Item"}
                    </h3>
                    <NotificationEntityPreview
                        entityId={entity_id}
                        type={type}
                    />
                </Fragment>
            )
        } else {
            let linkComponent = "No link"
            if (link) {
                linkComponent = (
                    <a href={link} target="_blank" rel="noopener noreferrer">
                        {link}
                    </a>
                )
            }
            linkContainerComponent = (
                <Fragment>
                    <h3>
                        <i className="icon icon-article" />
                        Link
                    </h3>
                    <p>{linkComponent}</p>
                </Fragment>
            )
        }
    }
    return (
        <div className="widget">
            <div className="widget-content">
                <h3 className="first-heading">
                    <i className="icon icon-insights" />
                    Notification type
                </h3>
                <ContentLoaderTags
                    isFetching={isFetching}
                    tags={1}
                    tagLength={20}
                >
                    {type ? (
                        <Tags>
                            <TagItem isGrey={true}>
                                {getDisplayTagFromType(type)}
                            </TagItem>
                        </Tags>
                    ) : (
                        <p>No type</p>
                    )}
                </ContentLoaderTags>
                {linkContainerComponent}
            </div>
        </div>
    )
}

export default NotificationViewLinkDetails
